export class GenericDialog {
  titel: string;
  text: string;
  details?: string;
  hideCancel?: boolean;
  okLabel?: string;
  cancelLabel?: string;
}
